import { Pipe, PipeTransform } from '@angular/core';
import { convertToHumanReadable } from 'app/trello/utility/duration-formatter';

@Pipe({
  name: 'readableMilliseconds',
  pure: true,
})
export class ReadableMillisecondsPipe implements PipeTransform {

  transform(
    value: number | null | undefined,
    maxUnits: number = 1,
  ): string {

    if (value === null || value === undefined) {
      return '';
    }

    const scaledValue = {milliseconds: value};

    return convertToHumanReadable(scaledValue, maxUnits);
  }

}
